import { Component, type ErrorInfo, type ReactNode } from 'react';

export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error('Application boundary', error, info.componentStack);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="fatal-screen">
          <section className="error-notice" role="alert">
            <h1>That trail hit an unexpected turn.</h1>
            <p>No sensitive details were exposed. Reload the page to safely try again.</p>
            <button type="button" onClick={() => window.location.reload()}>
              Reload Wild Trails
            </button>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}
